.track {
  --page-scrollbar-track-hover: rgba(30, 77, 196, 0.08);
  --page-scrollbar-thumb: rgba(30, 77, 196, 0.62);
  --page-scrollbar-thumb-hover: rgba(30, 77, 196, 0.78);
  --page-scrollbar-thumb-drag: #1e4dc4;
  --page-scrollbar-thumb-shadow: rgba(30, 77, 196, 0.2);
  position: fixed;
  top: 14px;
  right: 8px;
  z-index: 120;
  width: 14px;
  border-radius: 999px;
  background: transparent;
  opacity: 0.5;
  pointer-events: auto;
  touch-action: none;
  transition:
    background 0.18s ease,
    opacity 0.18s ease;
}

.track[data-page-scrollbar-surface='dark'] {
  --page-scrollbar-track-hover: rgba(127, 168, 255, 0.1);
  --page-scrollbar-thumb: rgba(127, 168, 255, 0.82);
  --page-scrollbar-thumb-hover: rgba(127, 168, 255, 0.94);
  --page-scrollbar-thumb-drag: #7fa8ff;
  --page-scrollbar-thumb-shadow: rgba(127, 168, 255, 0.3);
}

.track[data-visible='true'] {
  opacity: 0.88;
}

.track[data-hovered='true'],
.track[data-dragging='true'] {
  background: var(--page-scrollbar-track-hover);
  opacity: 1;
}

.thumb {
  position: absolute;
  left: 50%;
  top: 0;
  width: 6px;
  min-height: 48px;
  border-radius: 999px;
  background: var(--page-scrollbar-thumb);
  box-shadow: 0 3px 14px var(--page-scrollbar-thumb-shadow);
  translate: -50% 0;
  cursor: pointer;
  touch-action: none;
  transition:
    width 0.18s var(--ease-out),
    background 0.18s ease,
    box-shadow 0.18s ease;
}

.track[data-hovered='true'] .thumb {
  width: 8px;
  background: var(--page-scrollbar-thumb-hover);
}

.track[data-dragging='true'] .thumb {
  width: 10px;
  background: var(--page-scrollbar-thumb-drag);
  box-shadow: 0 6px 18px var(--page-scrollbar-thumb-shadow);
}

.mobileProgress {
  display: none;
}

.mobileProgressFill {
  display: block;
  width: 100%;
  height: 100%;
  border-radius: inherit;
  transform-origin: 50% 0;
  transition: none;
  will-change: transform;
}

@media (max-width: 900px) {
  .mobileProgress {
    --page-scroll-progress-track: rgba(30, 77, 196, 0.14);
    --page-scroll-progress-fill: rgba(30, 77, 196, 0.88);
    position: fixed;
    top: max(10px, env(safe-area-inset-top));
    right: 3px;
    bottom: max(10px, env(safe-area-inset-bottom));
    z-index: 120;
    display: block;
    width: 3px;
    overflow: hidden;
    border-radius: 999px;
    background: var(--page-scroll-progress-track);
    pointer-events: none;
  }

  .mobileProgress[data-page-scrollbar-surface='dark'] {
    --page-scroll-progress-track: rgba(127, 168, 255, 0.16);
    --page-scroll-progress-fill: #7fa8ff;
  }

  .mobileProgressFill {
    background: var(--page-scroll-progress-fill);
  }
}

@media (max-width: 900px), (pointer: coarse), (prefers-reduced-motion: reduce) {
  .track {
    display: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .mobileProgressFill {
    transition: none !important;
  }
}
